<template>
    <div class="edit_wrap">
        <!-- tab -->
        <div class="add_top">
            <div class="add_tab active_tab">品牌品类详情</div>
        </div>

        <!-- 品牌详情 -->
        <div class="choice_brand mt20 mb20">
            <!-- 中英文名称 -->
            <div class="add_name">
                <div class="c_name">
                    <span class="form_color">品牌中文名称：</span>
                    <span class="f999">{{brandDetail.brandName}}</span>
                    <span class="main_word"  v-if="snapshot.brandName">&nbsp;&nbsp; {{ snapshot.brandName }}</span>
                </div>
                <div class="e_name">
                    <span class="form_color">品牌英文名称：</span>
                    <span class="f999">{{brandDetail.brandEnname}}</span>
                    <span class="main_word" v-if="snapshot.brandEnname">&nbsp;&nbsp; {{ snapshot.brandEnname }}</span>
                </div>
                <div class="e_name">
                    <span class="form_color">品牌合作品类：</span>
                </div>
                <!--表格-->
                <el-table :data="brandDetail.categories" border style="width: 100%;margin-left: -20px">
                    <el-table-column label="主营品类"
                                     width="200"
                                     align="center">
                        <template scope="scope">
                            <span>{{ scope.row.category.grandName }}--</span>
                            <span>{{ scope.row.category.parentName }}--</span>
                            <span>{{ scope.row.category.childrenName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="是否提供发票"
                                     width="150"
                                     align="center">
                        <template scope="scope">
                            <span v-if="scope.row.provideInvoice==0">否</span>
                            <span v-if="scope.row.provideInvoice==1">是</span>
                        </template>
                    </el-table-column>
                    <!-- 发票类型 判断不完整 看注释-->
                    <el-table-column label="发票类型" align="center" width="180">
                        <template scope="scope">
                            <span v-if="scope.row.provideInvoice==0">无</span>
                            <span v-if="scope.row.provideInvoice==1 && registeredCountry == 1 && scope.row.invoiceType == 1">增值税普通发票</span>
                            <span v-if="scope.row.provideInvoice==1 && taxpayerType==1 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票</span>
                            <span v-if="scope.row.provideInvoice==1 && taxpayerType==2 && registeredCountry == 1 && scope.row.invoiceType == 2">增值税专用发票（需去税务局代开）</span>
                            <span v-if="scope.row.provideInvoice==1 && registeredCountry != 1 && scope.row.invoiceType == 3">形式发票</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="税率" align="center" min-width="200">
                        <template scope="scope"
                                  v-if="scope.row.rates !=null && scope.row.rates != undefined ">
                            <span v-if="scope.row.rates.length==0">无</span>
                            <span v-if="scope.row.rates.length>0" v-for="rateValue in scope.row.rates">
                                    {{rateValue}}%
                                    </span>
                        </template>
                    </el-table-column>

                    <el-table-column width="200" label="品类经营特许资质电子版" align="center">
                        <template scope="scope" >
                            <img class="pic_skan" v-if="scope.row.franchiseQualification" :src="scope.row.franchiseQualificationFile" alt="" @click="previewPic($event)">
                            <span v-if="!scope.row.franchiseQualification == 1">不需要</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div align="center" class="mt20">
                <el-button type="primary" @click="reback()">返回</el-button>
            </div>
            <!--预览图片-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img  width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
        </div>

    </div>
</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                registeredCountry: 0,   // 注册地
                taxpayerType: 0,        // 纳税人类型
                deptId:0,               // 部门id

                loading:false,
                // 图片预览
                dialogImageUrl: '',
                dialogVisible: false,
                isChoice: true,				// tab 当前页面
                search_result: false,		// 搜索结果弹框
                brand_key: '',			// 品牌关键字搜索
                radio: null,							// 选中的内容,
                options: [],
                hasSelBrand:0,
                brandId:'',
                brandApplyId : 0,
                status : 0,                                        // 申请状态,Integer
                // 非图书 申请品牌信息
                brandDetail: {
                    categories: [],
                    brandApplyId:  0,                                // 品牌申请id,Integer
                    supplierApplyId :  0,                             // 供应商申请id,Integer
                    brandId:0,                                         // brandId
                    brandName :  "",                                 // 品牌名称,String
                    brandEnname :  "",                              // 英文名称,String
                    brandDesc :  "",                          // 品牌介绍,String
                    brandGoodsDesc :  "",                            // 重点商品介绍,String
                    categoryIsBook : 0,                                // 品类是否为图书,Integer：0否，1是
                    registeredCountry : 0,                             // 注册国家,Integer：1中国
                    businessType :  0,                                  // 经营方式（1：自有品牌 2：代理商 3：其他）
                    goodsType :  0,                                     // 商品类型（1：非进口 2：进口）
                },
                snapshot: {}
            }
        },

        mounted () {
            var brandApplyId = this.$route.query.brandApplyId;
            if(this.$route.query.hasSelBrand) {
                this.hasSelBrand = this.$route.query.hasSelBrand;
            }
            this.brandApplyId = brandApplyId;
            if(brandApplyId){
                this.initBrandDetail(brandApplyId);
            }
        },

        methods: {
            initBrandList(query) {
                var that = this;
                if (query !== '') {
                    /*获取品牌数据*/
                    $.get({
                        url: '/suppliers/supplierSettled/findBrandByKeyword',
                        dataType: "json",
                        data: {brandName:query},
                        success: function (result) {
                            if (!result.code) {
                                that.options = result.data.list;
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: result.msg,
                                    type: 'error'
                                });
                            }
                        },
                        error : function (err) {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    });
                }
            },

            // 预览图片
            previewPic (e) {
                console.log(e)
                this.dialogVisible = true;
                // 获取当前图片地址
                this.dialogImageUrl = e.currentTarget.src;
            },

            /**
             * 保存品牌关联关系
             */
            saveBrandRelation () {
                var that = this;
                if (!that.brandId) {
                    this.$message.error('请选择品牌');
                    return;
                }
                if(!that.brandApplyId) {
                    this.$message.error('申请的品牌信息有误');
                    return;
                }

                $.get({
                    url: '/suppliers/supplierSettled/brand/update',
                    dataType: "json",
                    data: {
                        applyBrandId : that.brandApplyId,
                        brandId : that.brandId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.$alert('品牌保存成功', '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    window.opener.eventHub.$emit('reloadBrandList',null);
                                    window.close();
                                }
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                });
            },

            initBrandDetail(brandApplyId){
                var that = this;
                $.get({
                    url: '/suppliers/agreementApply/brandApplyAndSnapshot/find',
                    data: {
                        brandApplyId: brandApplyId
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.brandDetail = result.data.lastest;
                            that.snapshot = result.data.snapshot;
                            that.registeredCountry = result.data.lastest.registeredCountry;
                            that.taxpayerType = result.data.lastest.taxpayerType;
                            that.deptId = result.data.lastest.deptId;
                            if (that.brandDetail.brandId) {
                                that.brandId = that.brandDetail.brandId;
                            } else {
                                that.brandId = '';
                            }
                            that.status = that.brandDetail.status;
                            if(that.snapshot) {
                                if(!that.snapshot.trademarkRegistrationCertificateFile){
                                    that.snapshot.trademarkRegistrationCertificateFile = "";
                                }
                                if(!that.snapshot.purchaseOrderFile){
                                    that.snapshot.purchaseOrderFile = "";
                                }
                                if(!that.snapshot.authCertificateFile){
                                    that.snapshot.authCertificateFile = "";
                                }
                                if(!that.snapshot.qualityInspectionFile){
                                    that.snapshot.qualityInspectionFile = "";
                                }
                                if(!that.snapshot.customsDeclarationFormFile){
                                    that.snapshot.customsDeclarationFormFile = "";
                                }
                                if(!that.snapshot.inspectionQuarantineFile){
                                    that.snapshot.inspectionQuarantineFile = "";
                                }
                                if(!that.snapshot.taxFormFile){
                                    that.snapshot.taxFormFile = "";
                                }
                                if(!that.snapshot.goodsFormFile){
                                    that.snapshot.goodsFormFile = "";
                                }
                            }
                        } else {

                        }
                    }
                })
            },
            reback(){
                history.go(-1);
//                window.close();
            }
        },
        computed: {
            amount: function () {
                return 200 - this.addForm.brandDesc.length;
            }
        }
    }

</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
    // height: 4000px;
        margin: 50px auto;
        border: 1px solid #eee;
    .add_top {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
    }
    .add_tab {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #666;
        font-size: 14px;
        cursor: pointer;
    }
    .active_tab {
        border-bottom: 1px solid #ff4a7d;
        color: #ff4a7d;
    }
    .add_name {
        padding-left: 40px;
    }
    }
    .choice_brand {
        min-height: 300px;
    }
    .w500 {
        width: 500px;
    }
    .w250 {
        width: 250px;
    }
    .w165 {
        width: 165px;
    }
    .radio_group {
        width: 90%;
        padding-left: 15%;
        max-height: 150px;
        overflow-y: scroll;
    }
    .list_radio {
        margin-top: 10px;
        margin-left: 10%;
        width: 40%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .result_radio .el-radio + .el-radio {
        margin-left: 10%;
    }
    .dialog-footer {
        text-align: center;
    }
    .form_color {
        color: rgb(106, 72, 77);
    }
    .c_name, .e_name {
        line-height: 36px;
    }
    .el-form-item {
        margin-bottom: 0;
    }
    .pic_skan {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .pic_skan_red {
        width: 150px;
        height: 150px;
        margin-top: 5px;
        border: 2px solid #ff4a7d;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .ml150 {
        margin-left: 150px;
    }
    .ml100 {
        margin-left: 100px;
    }
    .w140{
        width: 140px;
    }
</style>


// WEBPACK FOOTER //
// supple_brand_detail.vue?836b8240